import { render, staticRenderFns } from "./TextBlock.vue?vue&type=template&id=a8b16e54&scoped=true"
import script from "./TextBlock.vue?vue&type=script&lang=js"
export * from "./TextBlock.vue?vue&type=script&lang=js"
import style0 from "./TextBlock.vue?vue&type=style&index=0&id=a8b16e54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b16e54",
  null
  
)

export default component.exports